import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let WholePortionPredriedPreparationSingleTraySection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection heading="Sampled Mass">
    <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
      {/* The same balance is used to measure TareMass and TareAndDryMass. Copying
      the value is a simple workaround that avoids implementing a config function
      for `measuredUsing`.  */}
      <WorksheetBalanceFieldSet name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
      <Field input={<NumericInput />} name="TareMass" />
      <Field input={<NumericInput />} name="TareAndDryMass" />
    </NamePrefixModifier>
    <NamePrefixModifier appendNamePrefix="Masses">
      <Field input={<TextOutput />} name="MassMeasurement.DryMass" additionalMessagePaths={['DryMass']} />
    </NamePrefixModifier>
  </ListFieldSection>
);
WholePortionPredriedPreparationSingleTraySection = withInjectedProps(WholePortionPredriedPreparationSingleTraySection);

export { WholePortionPredriedPreparationSingleTraySection };
export default WholePortionPredriedPreparationSingleTraySection;
